// Bugfix 23 (#1393): selectievakjes in het ledenoverzicht. Houdt de teller en
// de bulkbalk bij, selecteert alle zichtbare leden en sluit een open
// actiemenu zodra je ergens anders tikt (belangrijk op een tablet).
import { Controller } from "stimulus"
import { verstuurZonderLegeVelden } from "./leden_filters_controller"

export default class extends Controller {
  static targets = ["vak", "alles", "balk", "teller", "rij", "menu"]
  static values = { een: String, meer: String }

  connect() {
    this.sluitMenus = this.sluitMenus.bind(this)
    document.addEventListener("click", this.sluitMenus)
    this.bijwerken()
  }

  disconnect() {
    document.removeEventListener("click", this.sluitMenus)
  }

  alles(event) {
    this.vakTargets.forEach((vak) => { vak.checked = event.target.checked })
    this.bijwerken()
  }

  wijzig() {
    this.bijwerken()
  }

  wis() {
    this.vakTargets.forEach((vak) => { vak.checked = false })
    this.bijwerken()
  }

  verstuurFilters() {
    const formulier = document.getElementById("lo_filters")
    if (formulier) verstuurZonderLegeVelden(formulier)
  }

  bijwerken() {
    const gekozen = this.vakTargets.filter((vak) => vak.checked)
    const aantal = gekozen.length
    this.vakTargets.forEach((vak) => {
      vak.closest("tr")?.classList.toggle("is-geselecteerd", vak.checked)
    })
    if (this.hasAllesTarget) {
      this.allesTarget.checked = aantal > 0 && aantal === this.vakTargets.length
      this.allesTarget.indeterminate = aantal > 0 && aantal < this.vakTargets.length
    }
    if (this.hasBalkTarget) this.balkTarget.hidden = aantal === 0
    if (this.hasTellerTarget) {
      this.tellerTarget.textContent = aantal === 1 ? this.eenValue : this.meerValue.replace("__AANTAL__", aantal)
    }
  }

  sluitMenus(event) {
    this.menuTargets.forEach((menu) => {
      if (menu.open && !menu.contains(event.target)) menu.open = false
    })
    // Eén menu tegelijk open
    const geopend = event.target.closest?.("details.lo-menu")
    if (geopend) {
      this.menuTargets.forEach((menu) => { if (menu !== geopend) menu.open = false })
    }
  }
}
